import React from 'react';

const PLATFORMS = [
  { id: 'amazon', label: 'Amazon', emoji: '📦' },
  { id: 'flipkart', label: 'Flipkart', emoji: '🛒' },
  { id: 'myntra', label: 'Myntra', emoji: '👗' },
  { id: 'meesho', label: 'Meesho', emoji: '🏷️' },
  { id: 'snapdeal', label: 'Snapdeal', emoji: '⚡' },
  { id: 'nykaa', label: 'Nykaa', emoji: '💄' },
  { id: 'ajio', label: 'AJIO', emoji: '🧥' },
  { id: 'own_website', label: 'Own Website', emoji: '🌐' },
  { id: 'instagram', label: 'Instagram', emoji: '📸' },
  { id: 'whatsapp', label: 'WhatsApp', emoji: '💬' },
  { id: 'other', label: 'Other', emoji: '➕' },
];

const PlatformSelector = ({ selected, onChange }) => {
  const toggle = (id) => {
    if (selected.includes(id)) {
      onChange(selected.filter(p => p !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">
        Selling Platforms <span className="text-gray-400 font-normal">(select all that apply)</span>
      </label>
      <div className="grid grid-cols-2 gap-2">
        {PLATFORMS.map(({ id, label, emoji }) => {
          const isSelected = selected.includes(id);
          return (
            <button key={id} type="button" onClick={() => toggle(id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg border-2 text-sm font-medium transition-all duration-150 text-left
                ${isSelected
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-200 bg-white text-gray-600 hover:border-blue-300 hover:bg-blue-50/50'
                }`}>
              <span className="text-base">{emoji}</span>
              <span className="truncate">{label}</span>
              {isSelected && (
                <span className="ml-auto w-4 h-4 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
                  <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
              )}
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <p className="text-xs text-blue-600 mt-2 font-medium">
          ✓ {selected.length} platform{selected.length > 1 ? 's' : ''} selected
        </p>
      )}
    </div>
  );
};

export default PlatformSelector;